export class ProgramExtendedInfo
{
    private readonly maxTimeValue = 1440;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
            if((json.ScheduleStartTimeInMinuteOfDay && json.ScheduleStartTimeInMinuteOfDay.length > 0)
            && json.UseScheduleStartTimeEnabledFlag == false){
                //LXC start time processed for UI purpose here
                json.ScheduleStartTimeInMinuteOfDay.forEach((ele, i) => {
                    this.IsStartTime[i] = (ele.Value < this.maxTimeValue);
                });

            }
            else if (!json.UseScheduleStartTimeEnabledFlag)
            {
                this.IsStartTime1 = this.Schedule1StartTimeInMinuteOfDay <= this.maxTimeValue;
                this.IsStartTime2 = this.Schedule2StartTimeInMinuteOfDay <= this.maxTimeValue;
                this.IsStartTime3 = this.Schedule3StartTimeInMinuteOfDay <= this.maxTimeValue;
                this.IsStartTime4 = this.Schedule4StartTimeInMinuteOfDay <= this.maxTimeValue;
            }
            else
            {
                // Currently this is only used by rain dial, which only supports 3 programs.
                this.IsStartTime1 = json.IsSchedule1StartTimeEnabled;
                this.IsStartTime2 = json.IsSchedule2StartTimeEnabled;
                this.IsStartTime3 = json.IsSchedule3StartTimeEnabled;
            }

            this.IsGrowInDelayInSeconds = this.GrowInDelayInSeconds > 0;
            this.IsGrowInStartTimeInMinuteOfDay = this.GrowInStartTimeInMinuteOfDay <= this.maxTimeValue;
            this.IsGrowInStopTimeInMinuteOfDay = this.GrowInStopTimeInMinuteOfDay <= this.maxTimeValue;
            this.IsGrowInRunTimeInSeconds = this.GrowInRunTimeInSeconds > 0;

            this.IsMvPumpDelayInSeconds = this.MvPumpDelayInSeconds > 0;
            this.IsZoneDelayInSeconds = this.ZoneDelayInSeconds > 0;
        }
    }

    public Schedule1StartTimeInMinuteOfDay: number;
    public Schedule2StartTimeInMinuteOfDay: number;
    public Schedule3StartTimeInMinuteOfDay: number;
    public Schedule4StartTimeInMinuteOfDay: number;
    //TODO LXC
    public ScheduleStartTimeInMinuteOfDay: { Id: number, Value: number }[] = [];
    public StationRuntimes: number[] = [];
    public SoilSensor1IsSet: boolean;
    public SoilSensor2IsSet: boolean;
    public SoilSensor3IsSet: boolean;
    public WeatherSensorIsSet: boolean;
    public RainSensorIsSet: boolean;

    public MvPumpDelayInSeconds: number;
    public ZoneDelayInSeconds: number;

    public RestrictionStartTimeInMinuteOfDay: number;
    public RestrictionStopTimeInMinuteOfDay: number;

    public IntPeriod: number;

    public GrowInDelayInSeconds: number;
    public GrowInStartTimeInMinuteOfDay: number;
    public GrowInStopTimeInMinuteOfDay: number;
    public GrowInRunTimeInSeconds: number;

    public IsGrowInDelayInSeconds: boolean;
    public IsGrowInStartTimeInMinuteOfDay: boolean;
    public IsGrowInStopTimeInMinuteOfDay: boolean;
    public IsGrowInRunTimeInSeconds: boolean;

    public MvOnDuringStationDelay: number;

    public IsMvPumpDelayInSeconds: boolean;
    public IsZoneDelayInSeconds: boolean;

    public IsStartTime1: boolean;
    public IsStartTime2: boolean;
    public IsStartTime3: boolean;
    public IsStartTime4: boolean;
    //TODO LXC
    public IsStartTime: boolean[] = [];
    public Trigger1?: number;
    public Trigger2?: number;
    public ActiveMvPump: number;

    public ProgramPercentAdjust: number;
    public SensorAdjustEnabled: boolean;
}
